import { useState, useRef } from "react";
import { api } from "@/lib/api";
import { Upload, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";

export default function FileUploader({ token, onUploaded, accept = "image/*,video/*", label = "Subir archivo" }) {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const maxSize = 50 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error("Archivo muy grande (máximo 50MB)");
      return;
    }

    setUploading(true);
    setProgress(10);
    try {
      const interval = setInterval(() => {
        setProgress(p => Math.min(p + 15, 85));
      }, 300);

      const res = await api.uploadFile(file, token);
      clearInterval(interval);
      setProgress(100);

      if (res.data?.url) {
        onUploaded(res.data.url);
        toast.success("Archivo subido");
      }
    } catch (err) {
      toast.error("Error al subir archivo");
    } finally {
      setUploading(false);
      setProgress(0);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="relative">
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleFile}
        className="hidden"
        data-testid="file-upload-input"
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        data-testid="file-upload-btn"
        className="flex items-center gap-2 px-4 py-2 bg-neutral-800 border border-neutral-700 rounded-full text-sm text-neutral-300 hover:text-white hover:border-neutral-600 transition-all disabled:opacity-50"
      >
        {uploading ? (
          <>
            <Loader2 size={14} className="animate-spin" />
            Subiendo {progress}%
          </>
        ) : (
          <>
            <Upload size={14} />
            {label}
          </>
        )}
      </button>
      {uploading && (
        <div className="mt-2 h-1 bg-neutral-800 rounded-full overflow-hidden">
          <div
            className="h-full bg-white/60 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
  );
}
